/**
 * Global context for session
 * To access global context: 
 * const { loginStandard, singleSignOn, logout, isLogin, getToken  } = useSession();
 */
import React, { createContext, useContext } from 'react';
import swal from "sweetalert";
import http from "api/precision/Endpoint";
// import SHA256 from "crypto-js/sha256";

const SessionContext = createContext();

export function SessionProvider({ children }) {

  /**
   * Helper function for loginSHA256 login
   * @param {*} message 
   * @returns 
   */
  async function digestMessage(message) {
    const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""); // convert bytes to hex string
    return hashHex;
  }

  /**
   * token = SHA256(getparameter + secret)
   * SHA256("2177-Sees=!@-12345") = cecbc0d6c7abb0dcb6f609d8ad6c0b09af1dc87da5ff042b373620ca97fdc4ec
   * To list products: remove pid, keep pcid
   * To customize product keep pid, remove category Id
   * @param srting search - Get parameter
   */
  const loginSHA256 = (search) => {
    // debugger;

    if (search) {
      const params = new URLSearchParams(search);
      const customerId = params.get("cid");
      const sessionId = params.get("sid");
      const categoryId = params.get("pcid");
      const productId = params.get("pid");
      const userId = params.get("uid");
      
      // 1 = customize, 2 - cart checkout
      const frameId = params.get("fid");
      const secret = process.env.REACT_APP_SEE_SECRET;
      // debugger;
      digestMessage(`${customerId}-${secret}-${sessionId}`)
        .then((digestHex) => {
          if (params.get("token") == digestHex) {
            const json = {
              "cid": customerId, "sid": sessionId,
              "pcid": categoryId, "pid": productId,
              "uid": userId, "fid": frameId, "token": digestHex
            };
            sessionStorage.setItem('profile', JSON.stringify(json));

            const formData = new FormData();
            formData.append("username", "kennyt@psggo.com");
            formData.append("password", "Direct16");
            formData.append("method", "user");
            http().post("/auth", formData).then(() => {
              document.location = "/sees";
            });
          }
        });
    }
  }

  /**
   * For nationwide friends and family
   * @param string email
   */
  const loginEmailOnly = (email) => {
    const loginFormData = new FormData();
    loginFormData.append("email", email);
    http().post("/login", loginFormData)
      .then((res) => {
        if (res.data.result === 1) {
          sessionStorage.setItem('profile', JSON.stringify(res.data.data));
        }
        else {

        }
      })
      .catch((error) => {
        console.log(error);
      });

    // return new Promise(resolve => {
    //   setTimeout(() => resolve(true), 1000);
    // });
  }

  /**
   * Login by user name and password
   * @param {*} username 
   * @param {*} password 
   * @returns 
   */
  const loginStandard = (username, password) => {
    const loginFormData = new FormData();
    loginFormData.append("username", username)
    loginFormData.append("password", password)
    http().post("/auth", loginFormData)
      .then((res) => {
        if (res.data.result == 1) {
          sessionStorage.setItem("profile", JSON.stringify(res.data));
          var data = {
            expired: res.data.expired
            , userId: res.data.profile.user_id
            , token: res.data.data
            , singleSignOn: res.data.single_sign_on
          }
          sessionStorage.setItem('session', JSON.stringify(data));
        }
        else {
          swal("Oops", "Invalid username or password", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return new Promise(resolve => {
      setTimeout(() => resolve(), 500);
    });
  }

  /**
   * Other method of login like address
   * @param {*} addressname 
   * @param {*} address 
   * @param {*} postalCode 
   */
  const loginAddress = (customerId, addressname, address, postalCode) => {
    const loginFormData = new FormData();
    loginFormData.append("customer_id", customerId);
    loginFormData.append("address_name", addressname);
    loginFormData.append("line1", address);
    loginFormData.append("zip_code", postalCode);

    http().post("/auth", loginFormData)
      .then((res) => {
        if (res.data.result === 1) {
          sessionStorage.setItem("profile", JSON.stringify(res.data.profile));
          var data = {
            expired: res.data.expired
            , userId: res.data.profile.user_id
            , token: res.data.data
            , singleSignOn: res.data.single_sign_on
          }
          sessionStorage.setItem('session', JSON.stringify(data));
        }
        else {
          swal("Oops", "Invalid login credential", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return new Promise(resolve => {
      setTimeout(() => resolve(), 500);
    });
  }

  /**
   * Login be a single signon token
   * @param string token 
   */
  const singleSignOn = (token) => {
    const loginFormData = new FormData();
    loginFormData.append("token", token);
    http().post("/auth", loginFormData)
      .then((res) => {
        if (res.data.result === 1) {
          sessionStorage.setItem("profile", JSON.stringify(res.data));
          var data = {
            expired: res.data.expired
            , userId: res.data.profile.user_id
            , token: res.data.data
            , singleSignOn: res.data.single_sign_on
          }
          sessionStorage.setItem('session', JSON.stringify(data));
        }
        else {
          swal("Oops", "Invalid login credential", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /**
   * Refresh token in amount of time in ms
   * @param int timer 
   */
  const refreshToken = (timer) => {
    setTimeout(() => {
      loginStandard();
    }, timer);
  }

  const logout = () => {
    sessionStorage.removeItem('session');
    sessionStorage.removeItem('profile');
  }

  /**
   * Check if user login
   * @returns boolean
   */
  const isLogin = () => {
    const str = sessionStorage.getItem('profile');
    return str ? true : false;
  }

  /**
   * @returns {*} user profile
   */
  const getProfile = () => {
    const str = sessionStorage.getItem('profile');
    return JSON.parse(str);
  }

  return (
    <SessionContext.Provider
      value={{
        loginSHA256,
        loginEmailOnly,
        loginStandard,
        loginAddress,
        singleSignOn,
        logout,
        isLogin,
        refreshToken,
        getProfile
      }}
    >
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  return useContext(SessionContext);
}
